<ng-container *ngFor="let language of sortedLanguages; let i = index; trackBy: trackByLanguageCode;">
  {{ language.languageCode | languageName }}<ng-container *ngIf="language.preferred && sortedLanguages && sortedLanguages.length > 1"> (Preferred)</ng-container><ng-container *ngIf="i < sortedLanguages.length - 1">, </ng-container>
</ng-container>
